<template>
    <main-layout>
        <base-header>
            <template #icon> mdi-file</template>
            <template #name> Edit Sales Order</template>
            <template #breadcrumbs>
                <v-breadcrumbs :items="breadcrumbs" class="pa-0">
                    <template #divider>
                        <v-icon>mdi-chevron-right</v-icon>
                    </template>
                </v-breadcrumbs>
            </template>
        </base-header>

        <v-card class="mx-1">
            <!-- App Bar -->
            <v-app-bar flat dense color="rgba(0, 0, 0, 0)">
                <v-toolbar-title> Reference No</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn small color="secondary" class="ma-2" @click="backForm()">
                    <v-icon>mdi-arrow-left</v-icon> Back
                </v-btn>
                <v-btn small class="ma-2" color="primary" @click.stop="update" :loading="btnLoading"
                    :disabled="!form_valid || btnLoading">
                    Update
                    <v-icon right>mdi-content-save-all</v-icon>
                </v-btn>
            </v-app-bar>

            <v-form ref="SalesOrder" v-model="form_valid" lazy-validation>
                <form-sales-order />
                <form-item />
            </v-form>
        </v-card>
    </main-layout>
</template>
  
<script>
import { mapGetters, mapMutations } from "vuex";
import FormSalesOrder from "./Form.vue";
import FormItem from "./FormItem.vue";
import MainLayout from "@/layouts/MainLayout.vue";
import BaseHeader from "@/components/base/BaseHeader.vue";
export default {
    name: "SalesOrderEdit",
    data() {
        return {
            btnLoading: false,
            form_valid: true,
        };
    },
    created() {
        this.breadcrumbs = [
            { text: "Transaction", disabled: false },
            { text: "Sales Order", disabled: true },
            { text: "Edit", disabled: true },
        ];
    },
    methods: {
        ...mapMutations("sales_order", ["CLEAR_STATE"]),
        update: async function () {
            if (this.$refs.SalesOrder.validate()) {
                this.btnLoading = true;
                this.SalesOrder.subtotal = this.SalesOrder.details.reduce(
                    (acc, cur) => acc + cur.amount,
                    0
                );
                this.SalesOrder.discount_amount = parseInt(this.SalesOrder.subtotal) * parseInt(this.SalesOrder.discount_percent) / 100;
                this.SalesOrder.afterDiscount = parseInt(this.SalesOrder.subtotal - this.SalesOrder.discount_amount);
                if (this.SalesOrder.use_vat == true) {
                    this.SalesOrder.vat = parseInt((this.SalesOrder.afterDiscount * 11)) / 100;
                } else {
                    this.SalesOrder.vat = 0;
                }
                this.SalesOrder.pph = parseInt(this.SalesOrder.afterDiscount * this.SalesOrder.pph_percentage) / 100;
                this.SalesOrder.grand_total = parseInt(this.SalesOrder.afterDiscount) + parseInt(this.SalesOrder.vat) - parseInt(this.SalesOrder.pph);
                await this.$axios
                    .put("/transaction/sales-orders/" + this.SalesOrder.id, this.SalesOrder,
                        {
                            headers: { Authorization: this.$store.getters["auth/Token"] },
                        })
                    .then(() => {
                        this.btnLoading = false;
                        this.CLEAR_STATE();
                        this.$router.push({ name: "sales-order.index" });
                    })
                    .catch(() => {
                        this.btnLoading = false;
                    });
            }
        },
        clear() {
            this.CLEAR_STATE();
        },
        backForm() {
            this.CLEAR_STATE();
            this.$router.push({ name: "sales-order.index" });
        },
    },
    computed: {
        ...mapGetters("sales_order", {
            SalesOrder: "SalesOrder",
        }),

        ...mapGetters("auth", {
            ROLE: "Role",
        }),
    },
    components: {
        MainLayout,
        BaseHeader,
        "form-sales-order": FormSalesOrder,
        "form-item": FormItem,
    },
};
</script>